<template>
  <div class="main">
    <toptab></toptab>
    <div class="newwhiteouter">
      <div id="demo" class="carousel slide" data-ride="carousel">
        <!-- 指示符 -->
        <ul class="carousel-indicators" style="bottom:-70px">
          <template v-for="(item,index) in projectbanner">
            <!-- <li data-target="#demo" :data-slide-to="index" class="active" :key="index"></li> -->
            <li data-target="#demo" :data-slide-to="index" :class="index==0? 'active':'' " :key="index"></li>
          </template>
        </ul>

        <!-- 轮播图片 -->
        <div class="carousel-inner">
          <template v-for="(item,index) in projectbanner">
            <div
              class="carousel-item"
              :class="index==0? 'active':'' "
              :key="index"
              :style="'background: #fff url('+item.image+') center center no-repeat;'"
            >
              <div class="text paddingallllll">
                <div class="textitle animated fadeInUp">
                  <b>{{item.title}}</b>
                </div>
                <div class="textinfo animated fadeInUp">{{item.little_title}}</div>
                <!-- <div class="textimg animated fadeInUp">
                  <a href="javascript:void(0);">
                    <img src="/static/index/more2.png" />
                  </a>
                </div>-->
              </div>
              <div class="blackcover"></div>
            </div>
          </template>
        </div>
        <!-- 左右切换按钮 -->
        <!-- <a class="carousel-control-prev" href="#demo" data-slide="prev" style="z-index:40">
          <img src="/static/左箭头.png" style="width:60px;height:70px" />
        </a>
        <a class="carousel-control-next" href="#demo" data-slide="next" style="z-index:40">
          <img src="/static/右箭头.png" style="width:60px;height:70px" />
        </a>-->
      </div>
    </div>
    <div class="mainouter whiteback paddingall">
      <div class="firstinfo">
        <div class="newstitle">
          <div class="animated fadeInUp">
            <b>{{detail.title}}</b>
          </div>
          <div class="hhhdate">
            <div class="hhhflex animated fadeInUp">
              <span class="zyjm-shijian" style="color:#F88535"></span>
              {{detail.created_at}}
            </div>
            <div class="hhhflex animated fadeInUp">
              <span class="zyjm-liulanliang" style="color:#F88535"></span>
              {{detail.view_num}}
            </div>
          </div>
        </div>
        <div class="newsinfo">
          <div class="newsleftimg animated fadeInUp">
            <img :src="detail.thumbnail" alt />
          </div>
          <div class="newsrightinfo">
            <div v-html="detail.contents" class="mainrightinfo animated fadeInUp"></div>
            <div class="newsimglist">
              <template v-for="(item,index) in detail.pictures">
                <img :src="item" alt :key="index" class="mainimgitem animation-scale-up" />
                <!-- <el-image :src="item" alt :key="index" class="mainimgitem" :preview-src-list="detail.pictures"></el-image> -->
              </template>
            </div>
          </div>
        </div>
        <!-- <div class="demo-image__preview">
           <el-image 
   :src="detail.pictures[0]" class=" animation-scale-up" 
    :preview-src-list="detail.pictures">
  </el-image>
        </div>-->

        <div class="maintitle" id="newsdetail">
          <b>其他公司活动</b>
        </div>
        <div class="mainlist" v-if="!isSmall">
          <template v-for="(item,_index) in recommends">
            <newsitem :key="_index" :project="item"></newsitem>
          </template>
        </div>
        <div class="mainlist" v-if="isSmall">
          <template v-for="(item,_index) in recommends">
            <newsitemitem :key="_index" :project="item"></newsitemitem>
          </template>
        </div>
      </div>
    </div>
    <footeritem></footeritem>
  </div>
</template>

<script>
import toptab from "../components/top-tab-item";
import newsitem from "../components/news-item";
import newsitemitem from "../components/news-item copy";
import footeritem from "../components/footer-item";
export default {
  components: {
    toptab,
    footeritem,
    newsitem,
    newsitemitem
  },
  data() {
    return {
      projectbanner: [],
      detail: "",
      id: "",
      recommends: [],
      isSmall: false
    }
  },
  created() {
    let { id } = this.$route.params
    this.id = id
    this.loadData();
    this.$nextTick(() => {
      require('../../utils/news-detail');
      this.$e.$on("smallWindow", () => {
        console.log(this.isSmall);
        this.isSmall = true
      })
      this.$e.$on("bigWindow", () => {
        console.log(this.isSmall);
        this.isSmall = false
      })
    })
    if (window.second) {
      console.log("llllllllllll");
      window.location.reload()
      window.second = false
    }
  },

  updated() {
    console.log("jjjjjjjjj", this.$route.params);
  },
  methods: {
    /**
     * 数据加载
     */
    loadData() {
      this.$axios.post(this.$url.newsDetail, { id: this.id })
        .then(res => {
          console.log(res.data);
          let { error_code, news, recomments } = res.data;
          if (error_code == 2001) {
            this.detail = news
            this.recommends = recomments

          }
        });
      this.$axios.post(this.$url.newsBanner, {})
        .then(res => {
          console.log(res.data);
          let { error_code, banners } = res.data;
          if (error_code == 2001) {
            this.projectbanner = banners
          }
        });
    }
  },
  watch: {
    "$route"(n, o) {
      console.log(n, o);
      let { id } = this.$route.params
      this.id = id
      this.loadData();
    }
  }
}
</script>
<style>
.el-image-viewer__close {
  top: 70px;
}
</style>

<style scoped>
@import "../css/padding.css";
@import "../css/animate.min.css";

.main {
  padding-top: 0.67rem;
}

#demo {
  width: 1920px;
  height: 492px;
  margin: 0 auto;
  /* max-height: 1080px;
  min-height: 8.6rem; */
}
#demo .carousel-inner {
  width: 100%;
  height: 492px;
  /* position: relative; */
  /* max-height: 1080px;
  min-height: 8.6rem; */
}
#demo .carousel-inner .carousel-item {
  padding-top: 1rem;
  width: 100%;
  height: 492px;
  background-size: cover;
  /* max-height: 1080px;
  min-height: 8.6rem; */
  position: relative;
}
#demo .carousel-inner .text {
  width: 1440px;
  /* margin: 0 auto; */
  font-size: 40px;
  color: white;
  z-index: 20;
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  display: block;
}

#demo .carousel-inner .text .textitle {
}

#demo .carousel-inner .text .textinfo {
}

/* #demo .carousel-inner .text .textimg {
  width: 1.8rem;
  height: 0.46rem;
  margin-top: 1.5rem;
}

#demo .carousel-inner .text .textimg img {
  width: 1.8rem;
  height: 0.46rem;
} */

.blackcover {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(49, 50, 51, 0.5);
}

.textitle {
  font-size: 0.6rem;
  margin-bottom: 0.58rem;
  text-align: center;
}
.textinfo {
  font-size: 0.25rem;
  text-align: center;
  line-height: 0.4rem;
}

.newwhiteouter {
  width: 100%;
  background-color: rgba(255, 255, 255, 1);
  height: 492px;
  /* max-height: 1080px;
  min-height: 8.6rem; */
}

.mainouter {
  width: 100%;
  padding: 1rem 0;
}
.whiteback {
  background-color: #fff;
}
.grayback {
  background-color: #f5f5f5;
}
.firstinfo {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 0.4rem;
}
.maintitle {
  font-size: 0.4rem;
  height: 0.4rem;
  border-left: 4px solid #ff6900;
  line-height: 0.4rem;
  padding-left: 0.1rem;
  margin-bottom: 0.4rem;
}
.firstmain {
  display: flex;
  margin-bottom: 0.6rem;
}
.firstimg {
  width: 24%;
}
.firstimg img {
  width: 100%;
}
.mapimg {
  width: 20%;
}
.mapimg img {
  width: 100%;
}
.firstinfoinfo {
  width: 55%;
  font-size: 0.2rem;
}

.mapinfo {
  width: 100%;
  font-size: 0.2rem;
  margin-bottom: 0.4rem;
}

.bodythree {
  width: 100%;
  height: 3.14rem;
  background: #fff url(../../static/aboutmid.png) center center no-repeat;
  background-size: cover;
}

.threelist {
  width: 1440px;
  height: 3.14rem;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin: 0 auto;
}
.threeitem {
  width: 1.7rem;
  text-align: center;
  height: 1.1rem;
  margin: auto 0;
  color: white;
}
.threetitle {
  font-size: 0.5rem;
  height: 0.5rem;
  margin-bottom: 0.3rem;
}
.threeinfo {
  font-size: 0.2rem;
}
.threeinfotwo {
  font-size: 0.15rem;
}

.mainlist {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.firstdetail {
  margin-left: 0.4rem;
}
.firsttitle {
  font-size: 0.24rem;
  line-height: 1.2rem;
}
.firsttime {
  font-size: 0.14rem;
  line-height: 0.4rem;
}
.mainimg {
  width: 100%;
  margin-bottom: 0.4rem;
}
.mainimg img {
  width: 100%;
}
.newstitle {
  display: flex;
  font-size: 0.3rem;
  line-height: 0.4rem;
  justify-content: space-between;
}

.hhhdate {
  font-size: 0.2rem;
  display: flex;
  justify-content: space-between;
}
.hhhflex {
  display: flex;
  font-size: 0.18rem;
  line-height: 0.4rem;
  margin-left: 0.6rem;
}
.hhhflex span {
  line-height: 0.4rem;
  font-size: 0.18rem;
  margin-right: 10px;
}
.newsinfo {
  display: flex;
  justify-content: space-between;
  margin: 0.4rem auto;
}
.newsleftimg {
  width: 100%;
  max-width: 30%;
}
.newsleftimg img {
  width: 100%;
}
.newsrightinfo {
  width: 100%;
  max-width: 60%;
}
.mainrightinfo {
  font-size: 0.18rem;
}
.newsimglist {
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: wrap;
}
.mainimgitem {
  width: 100%;
  max-width: 30%;
  margin: 0.2rem 1%;
}
@media (max-width: 1440px) {
  .threelist {
    width: 100%;
  }
  #demo .carousel-inner .text {
    width: 100%;
  }
  .threelist {
    width: 100%;
  }
}

@media (max-width: 1920px) {
  #demo {
    width: 100%;
  }

  #topdemo {
    width: 100%;
  }
  .firstinfo {
    width: 100%;
  }
}

@media (max-width: 992px) {
  .main {
    padding-top: 100px;
  }
  .maintitle {
    font-size: 60px;
    line-height: 60px;
    height: 60px;
  }
  .textinfo {
    font-size: 0.4rem;
  }

  .newstitle {
    display: flex;
    font-size: 50px;
    line-height: 60px;
    justify-content: space-between;
    flex-direction: column;
  }

  .hhhdate {
    font-size: 30px;
    display: flex;
    justify-content: flex-start;
    margin-top: 20px;
  }
  .hhhflex {
    display: flex;
    font-size: 30px;
    line-height: 0.4rem;
    margin-left: 0;
    margin-right: 60px;
  }
  .hhhflex span {
    line-height: 0.4rem;
    font-size: 30px;
    margin-right: 10px;
  }
  .mainrightinfo {
    font-size: 30px;
  }
  .newsleftimg {
    display: none;
  }

  .newsrightinfo {
    width: 100%;
    max-width: 100%;
  }

  .mainimgitem {
    width: 100%;
    max-width: 46%;
    margin: 0.2rem 1%;
  }

  .newsimglist {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
}

@media (max-width: 1300px) {
  #demo .carousel-inner .carousel-item {
    padding-top: 1.3rem;
  }
}
/* 动画库 */
[class*="animation-"] {
  animation-duration: 0.5s;
  animation-timing-function: ease-out;
  animation-fill-mode: both;
}

.animation-scale-up {
  animation-name: scale-up;
}

@keyframes scale-up {
  0% {
    opacity: 0;
    transform: scale(0.2);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/news-detail.vue